import { useEffect, useMemo } from 'react';
import { atomFamily, useRecoilCallback, useRecoilValue } from 'recoil';
import { configState, recordFilterState } from '../recoil/atoms';
import { initializeRecoilFamilyCallback, InitializeRecoilValueOptions } from '../recoil/initialization';

export interface RecoilRootEffectsProps {
  initializeOptions?: InitializeRecoilValueOptions;
}
export const RecoilRootEffects = ({ initializeOptions }: RecoilRootEffectsProps) => {
  const config = useRecoilValue(configState);

  const initializeRecoilFamily = useRecoilCallback(initializeRecoilFamilyCallback, []);

  const recordTypeNames = useMemo(() => config.aggregateDefinitions.map(a => a.name), [config]);

  useEffect(() => {
    initializeRecoilFamily(recordFilterState as ReturnType<typeof atomFamily>, recordTypeNames, initializeOptions);
  }, [recordTypeNames]);

  return <></>;
};
